import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import type { UnitFeature } from "@/types";

interface UnitTableFeatureFilterProps {
    features: UnitFeature[];
    selectedFeatures: number[];
    setSelectedFeatures: React.Dispatch<React.SetStateAction<number[]>>;
}

export const UnitTableFeatureFilter = ({
    features,
    selectedFeatures,
    setSelectedFeatures,
}: UnitTableFeatureFilterProps) => {
    const handleCheckBoxChange = (feature: number) => {
        setSelectedFeatures((prev) =>
            prev.includes(feature)
                ? prev.filter((f) => f !== feature)
                : [...prev, feature],
        );
    };

    const handleClearFilter = () => {
        setSelectedFeatures([]);
    };

    return features.length > 0 ? (
        <div>
            <h3>Features</h3>
            {features.map((feature) => (
                <div
                    key={feature.id}
                    className="tw:items-start tw:flex-row tw:flex tw:space-x-3 tw:space-y-0"
                >
                    <Checkbox
                        id={feature.slug}
                        onCheckedChange={() => handleCheckBoxChange(feature.id)}
                        checked={selectedFeatures.includes(feature.id)}
                    />
                    <Label
                        htmlFor={feature.slug}
                        className="tw:text-sm tw:font-normal tw:ml-2"
                    >
                        {feature.name}
                    </Label>
                </div>
            ))}
            <Button
                onClick={handleClearFilter}
                variant="link"
                className="tw:text-sm tw:font-normal"
            >
                Clear
            </Button>
        </div>
    ) : null;
};
